import { render, staticRenderFns } from "./indexTwo.vue?vue&type=template&id=971d116e&scoped=true"
import script from "./indexTwo.vue?vue&type=script&lang=js"
export * from "./indexTwo.vue?vue&type=script&lang=js"
import style0 from "./indexTwo.vue?vue&type=style&index=0&id=971d116e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971d116e",
  null
  
)

export default component.exports